import { axios } from '@/utils';

export const postBranchService = async (values: any) =>
  (await axios.post(`/branch`, values)).data.data;
export const patchBranchByIdService = async (id: string) =>
  (await axios.patch(`/users/branch/${id}`)).data.data;

export const getUsersByBranch = (id: string) => async () => {
  const {data} = await axios.get(`/users/branch`, {
    headers:{
      branch: id
    }
  });
  return data?.data ?? [];
}
export const getBranchByCompanyId = (id: string) => async () => {
  const {data} = await axios.get(`/branch/company/${id}`);

  return data?.data ?? [];
};
